// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1JyOl","title":"BackImages_title__2GAZG","images":"BackImages_images__2rS0C"};